import { useEffect, useState } from "react";
import { DashboardLayout } from "../_common/DashboardLayout";
import { analyticsListService, pingstationListService } from "../../utils/api";
import { WidgetPingstationStatus } from "../components/WidgetPingstationStatus";
import { StatusAnalyticsChart } from "../components/ChartStatusAnalytics";
import { AircraftAnalyticsChart } from "../components/ChartAircraftAnalytics";

export function Dashboard() {
    

    // State for filtering
    const [selectedPingStation, setSelectedPingStation] = useState("");
    const [pingstationList, setPingstationList] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
    const [statusData, setStatusData] = useState([]);
    const [aircraftData, setAircraftData] = useState([]);
    const [date, setDate] = useState(new Date());

    // Extract unique pingStationGuids from the data
    // const uniquePingStations = [
    //     ...new Set(data.map((item) => JSON.parse(item.status).pingStationGuid)),
    // ];

    function refreshData() {
        if (selectedPingStation === "") return;
        analyticsListService({ date: selectedDate, pingstation_id: selectedPingStation }, (response) => {
            console.log(response.data);
            if(response.success) {
                setStatusData(response.statusStats);
                setAircraftData(response.aircraftStats);
            }
        });

        setDate(new Date());
    }

    useEffect(() => {
        pingstationListService((data) => {
            if (data.success) {
                setPingstationList(data.active);
                if (data.active.length > 0) {
                    setSelectedPingStation(data.active[0]?.pingstation_id);
                }
            }
        });
    }, []);


    useEffect(() => {
        refreshData();
    }, [selectedPingStation, selectedDate]);

    // setInterval(() => {
    //     refreshData();
    // }, 60 * 1000);

    

    
    return <DashboardLayout route="/dashboard">
        <h1 className="text-4xl font-semibold">Dashboard <span className="text-sm text-gray-500">Last Updated: {date.toLocaleString()}</span></h1>


        <WidgetPingstationStatus pingstations={pingstationList} />

        {/** Show fields for analytics - list of pingstations and date */}
        <div className="mt-10">
            <h2 className="font-semibold block text-gray-500 mb-5">ANALYTICS</h2>
            <div className="flex justify-between mb-4">
                <select
                    className="border px-3 py-2 rounded-md"
                    value={selectedPingStation}
                    onChange={(e) => setSelectedPingStation(e.target.value)}
                >
                    {pingstationList.map((pingstation) => (
                        <option key={pingstation.pingstation_id} value={pingstation.pingstation_id}>
                            {pingstation.airport_code}
                        </option>
                    ))}
                </select>
                <input
                    type="date"
                    className="border px-3 py-2 rounded-md"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                />
            </div>
        </div>

        <div className="bg-white p-6 shadow-md rounded-lg mt-5 relative text-center">
            <h2 className="font-semibold block text-gray-500 mb-5">STATUS ANALYTICS</h2>
            <StatusAnalyticsChart filteredData={statusData} />
        </div>

        <div className="bg-white p-6 shadow-md rounded-lg mt-5 relative text-center">
            <h2 className="font-semibold block text-gray-500 mb-5">AIRCRAFT ANALYTICS</h2>
            <AircraftAnalyticsChart data={aircraftData} />
        </div>
    </DashboardLayout>
}